import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
} from "@mui/material";

const ManageReview = () => {
  const navigate = useNavigate();
  const [reviews, setReviews] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(5);

  const handleButtonClick = (action) => {
    if (action === "Add Review") {
      navigate("/add-review");
    } else if (action === "View Reviews") {
      navigate("/view-reviews");
    } else if (action === "Update Review") {
      navigate("/update-review");
    } else if (action === "Delete Review") {
      navigate("/delete-review");
    } else {
      alert(`${action} button clicked!`);
    }
  };

  // Function to fetch reviews from the backend
  const fetchReviews = async (page, limit) => {
    try {
      const response = await fetch(
        `http://localhost:5000/api/reviews?page=${page}&limit=${limit}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Fetched data:", data);

      setReviews(data.data);
      const totalItems = data.meta.total;
      console.log("Total items:", totalItems);
      setTotalPages(Math.ceil(totalItems / limit)); // Calculate total pages based on the limit
    } catch (error) {
      console.error("Error fetching reviews:", error);
    }
  };

  // Fetch reviews whenever the page or limit changes
  useEffect(() => {
    fetchReviews(currentPage, limit);
  }, [currentPage, limit]);

  // Handle page change in the pagination
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage + 1);
  };

  // Handle rows per page change
  const handleRowsPerPageChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
  };

  return (
    <div>
      <h1>Manage Reviews</h1>
      <div>
        {/* Table for displaying reviews using MUI Table */}
        <div>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="reviews table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Review ID</TableCell>
                  <TableCell align="left">Product Name</TableCell>
                  <TableCell align="left">Title</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reviews.map((review) => (
                  <TableRow key={review.id}>
                    <TableCell align="center">{review.id}</TableCell>
                    <TableCell>{review.product_name}</TableCell>
                    <TableCell>{review.title}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={totalPages * limit}
            rowsPerPage={limit}
            page={currentPage - 1}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange} // Added event handler for rows per page change
          />
        </div>

        {/* Buttons */}
        <div>
          <button onClick={() => handleButtonClick("Add Review")}>
            Add Review
          </button>
          <button onClick={() => handleButtonClick("View Reviews")}>
            View Reviews
          </button>
          <button onClick={() => handleButtonClick("Update Review")}>
            Update Review
          </button>
          <button onClick={() => handleButtonClick("Delete Review")}>
            Delete Review
          </button>
        </div>
      </div>
    </div>
  );
};

export default ManageReview;
